import * as yup from 'yup'

export const validateUpdateEventSpeaker = yup.object().shape({
    name: yup
    .string()
    .min(2, 'El Nombre debe tener más de 1 caracteres'),
    priority: yup
    .number()
    .nullable(),
})